export default __webpack_public_path__ + "static/media/Mask-Group-11-Yono.14f0e149.png";